import React from 'react';
import { Link } from 'react-router-dom';
import links from '../../../config/links';

const VerifiedRulesLink = (props) => {
    const link = `${links.verifiedRules}`;
    return (
        <Link to={{ pathname: link }} target={props.target}>{props.children}</Link>
    );
};

export default VerifiedRulesLink;
